import { AGENT_UPLOAD_MARKER_PREFIX } from "@/agents-v2/uploads/constants";

const filesByMarker = new Map<string, File>();

export const registerAgentUploadFile = (file: File, id: string): string => {
  const marker = `${AGENT_UPLOAD_MARKER_PREFIX}${id}`;
  filesByMarker.set(marker, file);
  return marker;
};

export const getRegisteredAgentUploadFile = (
  marker: unknown
): File | null => {
  if (typeof marker !== "string") return null;
  return filesByMarker.get(marker) ?? null;
};

export const unregisterAgentUploadFile = (marker: unknown): void => {
  if (typeof marker !== "string") return;
  filesByMarker.delete(marker);
};
